import React from 'react'
import { FaTimes } from 'react-icons/fa'

/**
 * Shared bottom-sheet shell used by the mobile filter panels
 * (mobileTripsFilter, mobileShiftsFilter). Renders nothing when closed.
 *
 * Provides the overlay + slide-up sheet, a title header with a close button,
 * a scrollable body for the filter fields (children), and a footer with
 * "Nullstill" (reset) and "Søk" (search) buttons, matching the desktop
 * search panels' reset/search pattern.
 */
const MobileFilterSheet = ({ open, title, onClose, onReset, onSearch, children }) => {
   if (!open) return null

   return (
      <div className="fixed inset-0 z-30 flex items-end justify-center">
         <div
            className="absolute inset-0"
            style={{
               backgroundColor: 'rgba(0, 0, 0, 0.35)',
               backdropFilter: 'blur(6px)',
               WebkitBackdropFilter: 'blur(6px)'
            }}
            onClick={onClose}
         />

         <div
            className="relative w-full max-w-lg bg-gray-100 rounded-t-2xl shadow-lg flex flex-col"
            style={{ maxHeight: '85vh' }}>
            <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200 bg-white">
               <h2 className="text-base md:text-lg font-semibold text-gray-800">{title}</h2>
               <button
                  type="button"
                  onClick={onClose}
                  className="text-gray-400 hover:text-gray-600 focus:outline-none"
                  aria-label="Lukk">
                  <FaTimes size={16} />
               </button>
            </div>

            <div className="flex-1 overflow-y-auto px-4 py-3 space-y-3 bg-white">{children}</div>

            <div className="flex items-center gap-2 px-4 py-3 border-t border-gray-200 bg-white">
               <button
                  type="button"
                  onClick={onReset}
                  className="flex-1 bg-gray-200 text-gray-700 text-sm md:text-base font-medium rounded-full px-4 py-2.5 md:py-3 focus:outline-none">
                  Nullstill
               </button>
               <button
                  type="button"
                  onClick={onSearch}
                  className="flex-1 bg-blue-500 text-white text-sm md:text-base font-medium rounded-full px-4 py-2.5 md:py-3 focus:outline-none">
                  Søk
               </button>
            </div>
         </div>
      </div>
   )
}

export default MobileFilterSheet
